module.exports = __webpack_public_path__ + "static/img/4c50a7a977be4330b0e3b1c896955b8.6c095e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/4c50a7a977be4330b0e3b1c896955b8.png
// module id = vhQU
// module chunks = 7